import React from 'react';
import ReportViewer from "./base/ReportViewer";

const StatistiquesPrises = () => {

    return (
        <div style={{height: "100%"}}>
            <ReportViewer reportName={"StatistiquesPrises"}/>
        </div>
    );
}
export default StatistiquesPrises;